export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./chevron-right.vue?vue&type=template&id=599381b2&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/icons/chevron-right.vue?vue&type=template&id=599381b2&
// module id = 933
// module chunks = 0